import React, { Children, useCallback } from 'react';
import * as RadixPopover from '@radix-ui/react-popover';

import { SuperSearchDropdownContext } from './SuperSearchDropdownContext';
import useSuperSearchDropdown from './useSuperSearchDropdown';

const SuperSearchDropdown = ({ children, handleSelectedData, }) => {
  const searchDropDownTwo = useSuperSearchDropdown();
  const { onSetSelectedRowNumber, onSetSearchStatus, onSetInputValue, onToggleDropDown, onSetData, state } = searchDropDownTwo;
  const { showDropDown } = state;

  const allChildren = Children.toArray(children);
  const containerChild = allChildren.find((c) => c.type === SuperSearchDropdownContainer);
  const anchorChildren = allChildren.filter((c) => c.type !== SuperSearchDropdownContainer);
  const containerChildren = containerChild?.props?.children;
  const containerWidth = containerChild?.props?.width
  const containerHeight = containerChild?.props?.height

  const handleOpenChange = useCallback(
    (open) => {
      if (!open) {
        onSetSelectedRowNumber(0);
        handleSelectedData();
        onSetSearchStatus(false);
        onSetInputValue('');
        onToggleDropDown(false);
        onSetData([])
      }
    },
    [handleSelectedData, onSetInputValue, onSetSearchStatus, onSetSelectedRowNumber, onSetData, onToggleDropDown],
  );

  const resolvedWidth = containerWidth == null ? 'var(--radix-popover-trigger-width)' : typeof containerWidth === 'number' ? `${containerWidth}px` : containerWidth;
  const resolvedHeight = containerHeight == null ? 'var(--radix-popover-content-available-height)' : typeof containerHeight === 'number' ? `${containerHeight}px` : containerHeight;

  const contentStyle = {
    width: resolvedWidth,
    maxHeight: resolvedHeight,
    zIndex: 50,
  };

  return (
    <SuperSearchDropdownContext.Provider value={searchDropDownTwo}>
      <RadixPopover.Root open={showDropDown} onOpenChange={handleOpenChange} modal={false}>
        <RadixPopover.Anchor asChild>
          <div>{anchorChildren}</div>
        </RadixPopover.Anchor>
        <RadixPopover.Portal>
          <RadixPopover.Content sideOffset={4} align='start' avoidCollisions onOpenAutoFocus={(event_) => event_.preventDefault()} style={contentStyle}>
            {containerChildren}
          </RadixPopover.Content>
        </RadixPopover.Portal>
      </RadixPopover.Root>
    </SuperSearchDropdownContext.Provider>
  );
};

export default SuperSearchDropdown;

const SuperSearchDropdownInput = ({ children }) => {
  return <>{children}</>;
};

SuperSearchDropdown.Input = SuperSearchDropdownInput;

const SuperSearchDropdownContainer = ({ children }) => {
  return <>{children}</>;
};

SuperSearchDropdown.Container = SuperSearchDropdownContainer;
